import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000",
  // withCredentials is not needed for token auth
});

// Optional: Add a request interceptor to automatically attach the token
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // or wherever you store the token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosClient;
